var React = require('react');

function MultipleColors (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("circle",{"className":"cls-1","cx":"49.01","cy":"44.57","r":"19.17","key":0}),React.createElement("circle",{"className":"cls-1","cx":"20.07","cy":"44.57","r":"19.17","key":1}),React.createElement("circle",{"className":"cls-1","cx":"34.92","cy":"20.07","r":"19.17","key":2})])]);
}

MultipleColors.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 69.08 64.64"};

module.exports = MultipleColors;

MultipleColors.default = MultipleColors;
